import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { ApiService } from "src/app/services/api.service";
import { environment } from "src/environments/environment";
import { FilterService } from "./filter.service";
import { UserActivityService } from "./useractivity.service";
import { NavigationService } from "./navigation.service";
import { GridStateService } from "./grid-state.service";
import { RequestCancelService } from "./request-cancel.service";
import { PhiSecurityService } from "./phi-security.service";

@Injectable({
  providedIn: "root",
})
export class DashboardService {
  public apiBaseUrl: any;
  module: any;
  moduleKey: any;
  dashboardName: any;

  sidebarSizeEventChanges = new Subject<any>();

  linkPageNavigation: any = {};
  getPageKey: any = [];
  dashboardKey: any;
  menuItems: any;
  dashboardDetailsOfNotes: any;

  constructor(
    private apiService: ApiService,
    private filterService: FilterService,
    private userActivityService: UserActivityService,
    private navigationService: NavigationService,
    private gridStateService: GridStateService,
    private requestCancelService: RequestCancelService,
    private phiSecurityService: PhiSecurityService
  ) {
    this.apiBaseUrl = environment.apiBaseUrl;
  }

  getModuleDetails() {
    return this.module;
  }
  setModuleDetails(module: any) {
    this.module = module;
  }

  getModuleAccess(obj: any) {
    let body = {
      username: obj.username,
      client_key: obj.client_key,
    };
    let url = `api/get-module-access`;
    return this.apiService.post(url, body);
  }

  getDashboardAccess(obj: any) {
    let body = {
      username: obj.username,
      client_key: obj.client_key,
      module_key: obj.module_key,
    };
    let url = `api/get-dashboard-access`;
    return this.apiService.post(url, body);
  }

  getPageAccess(obj: any) {
    let url = `api/get-page-access`;
    return this.apiService.post(url, obj);
  }

  getPageDetails(body: any) {
    if (body?.module_key == 100110) {
      let fileName = body?.fileName;
      return this.apiService.getPageJsonFromAssets(fileName);
    } else {
      let url = `kpi/get-json-file-data`;
      return this.apiService.post(url, body);
    }
  }

  getRefreshedLastDate(obj: any) {
    if (!obj["brand_key"]) return new Observable((ob) => ob.next(undefined));
    let url = `kpi/get-last-refreshed-date`;
    return this.apiService.post(url, obj);
  }

  getBrandBasedExceptions(obj: any) {
    let url = `kpi/get-filter-exceptions`;
    return this.apiService.post(url, obj);
  }

  getAllUserForImpersonate(data:any) {
    // let url = `api/get-impersonation-users`;
    // return this.apiService.post(url, data);
    // if(environment.typeOfEnv=='DEV') {
    // } else {
      // }
      let url = `api/get-all-users`;
      return this.apiService.get(url); 
  }

  getAllUser() {
    let url = `api/get-all-users`;
    return this.apiService.get(url);
  }

  userMenuModuleHandle(usermenu: any, item: any) {
    this.filterService.phiChecked = false;
    this.phiSecurityService.removePHIWarningOverlay();
    this.phiSecurityService.disableRestrictions();

    if (usermenu) {
      this.filterService.refreshData = false;
      this.filterService.brandCarry = false;

      // Filter reset in Nav track
      this.filterService.resetFilterAndPayloadInNavDetails();
      sessionStorage.removeItem("source_patient_id");
      let userStateData: any = this.userActivityService.getData();
      let key = Object.keys(userStateData.selectedFilters).length;
      if (key > 0) {
        this.filterService.resetFilter();
      }

      if (userStateData.selectedType != "") {
        this.userActivityService.setData({ selectedType: "" });
      }

      this.moduleKey = item.module_key;
      this.userActivityService.hierarchicalGridState = [];

      sessionStorage.removeItem("brandKeyForFilters");
      sessionStorage.removeItem("tbl_name_suffix");

      sessionStorage.removeItem("tbl_name_suffix_non_frm");
      // sessionStorage.removeItem("serverSidegridState");
      this.gridStateService.clearAll();

      // Select module
      this.setModuleDetails(item);
      sessionStorage.setItem("module", JSON.stringify(item));

      let keys = [100112, 100113, 100116, 100117];

      if (keys.includes(Number(item.module_key))) {
        let query = {
          cl_key: item.client_key,
          md_key: item.module_key
        }
        this.navigationService.routerNavigate(`direct/${item.module_nm}`, query)
      } else if (item.module_key == 100118) {
        let query = {
          cl_key: item.client_key,
          md_key: item.module_key
        }
        this.navigationService.routerNavigate(`du-admin/${item.module_nm}`, query)
      } else {
        let query = {
          cl_key: item.client_key,
          md_key: item.module_key,
        };
        this.navigationService.routerNavigate(
          `dashboard/${item.module_nm}`,
          query
        );
      }

      // Cancel all pending API calls when switching modules
      this.requestCancelService.cancelAllRequests();
      this.filterService.brandSelectWithBackNavigation = false;
    }
  }
}
